module.exports = __webpack_public_path__ + "img/calendar2-event-fill.fdb43754.svg";